import React, { Children, cloneElement, isValidElement } from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import { MenuItemLink } from 'react-admin'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { translate } from 'ra-core'
import compose from 'recompose/compose'
import { withStyles } from '@material-ui/core/styles'
import Hidden from '@material-ui/core/Hidden'

const styles = {
    menuButton : {
        width : 'auto'
    },
    userName : {
        fontSize : 16,
        marginLeft: 10
    }
}

class UserMenu extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        label: PropTypes.string.isRequired,
        logout: PropTypes.node,
        icon: PropTypes.node,
        translate: PropTypes.func.isRequired,
    }

    static defaultProps = {
        label: 'ra.auth.user_menu',
        icon: <AccountCircle />,
    }

    constructor(props) {
        super(props);
        this.state = {
            auth: true,
            anchorEl: null,
            user : JSON.parse(localStorage.getItem('user'))
        }
    }

    handleChange = (event, checked) => {
        this.setState({ auth: checked })
    }

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ anchorEl: null })
    }

    get_display_username(){
        const user = this.state.user
        if(!!user){
            if(user.first_name){
                return `${user.first_name} ${user.last_name}`
            }else{
                return user.username
            }
        }else{
            return ''
        }
    }

    render() {
        const { children, label, icon, logout, translate, classes } = this.props
        if (!logout && !children) return null
        const { anchorEl } = this.state
        const open = Boolean(anchorEl)

        return (
            <div>
                <Tooltip title={label && translate(label, { _: label })}>
                    <IconButton
                        aria-label={label && translate(label, { _: label })}
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup={true}
                        color="inherit"
                        onClick={this.handleMenu}
                        className={classes.menuButton}
                    >
                        {icon} 
                        <Hidden xsDown>
                            <span className={classes.userName} >{this.get_display_username()}</span>
                        </Hidden>
                    </IconButton>
                </Tooltip>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    onClose={this.handleClose}
                >
                    {Children.map(children, menuItem =>
                        isValidElement(menuItem) ?
                        cloneElement(menuItem, { onClick: this.handleClose }) : null
                    )}
                    <MenuItemLink
                      to="/change_password"
                      primaryText="Cambiar Contraseña"
                      onClick={(e) => console.log(e)}
                    />
                    {logout}
                </Menu>
            </div>
        )
    }
}

const enhance = compose(
    translate,
    withStyles(styles)
)

export default enhance(UserMenu)
